import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-refresh/only-export-components */
import { Button, cn } from '@massilia/ui';
import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { AirportAutocompleteField } from '../fields/airport-autocomplete-field.js';
import { AirportOnlyAutocompleteField } from '../fields/airport-only-autocomplete-field.js';
import CalendarField from '../fields/calendar-field.js';
import CheckboxField from '../fields/checkbox-field.js';
import ColorPickerField from '../fields/color-picker-field.js';
import { CountryAutocompleteField } from '../fields/country-autocomplete-field.js';
import DateField from '../fields/date-field.js';
import IncrementNumberField from '../fields/increment-number-field.js';
import MultiDateField from '../fields/multi-date-field.js';
import MultiSelectAutocompleteField from '../fields/multi-select-autocomplete-field.js';
import { NationalityAutocompleteField } from '../fields/nationality-autocomplete-field.js';
import NumberField from '../fields/number-field.js';
import PasswordField from '../fields/password-field.js';
import RadioGroupField from '../fields/radio-group-field.js';
import RangeField from '../fields/range-field.js';
import SelectField from '../fields/select-field.js';
import SwitchField from '../fields/switch-field.js';
import TextAreaField from '../fields/text-area-field.js';
import TextField from '../fields/text-field.js';
import TimeField from '../fields/time-field.js';
import TravelClassField from '../fields/travel-class-field.js';
export const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();
function SubscribeButton({ backClassName, containerClassName, nextClassName, backLabel, hidden, nextLabel, onBackPressed, }) {
    const form = useFormContext();
    if (hidden?.both)
        return null;
    return (_jsx(form.Subscribe, { selector: (state) => ({ isSubmitting: state.isSubmitting }), children: ({ isSubmitting }) => (_jsxs("div", { className: cn('flex flex-row justify-end gap-2', containerClassName), children: [_jsx(Button, { className: cn('px-5 py-2', backClassName), disabled: isSubmitting, hidden: hidden?.back, onClick: onBackPressed, type: "button", variant: "outline", children: backLabel ?? 'Retour' }), _jsx(Button, { className: cn('px-5 py-2', nextClassName), disabled: isSubmitting, hidden: hidden?.next, type: "submit", children: nextLabel ?? 'Suivant' })] })) }));
}
export const { useAppForm, withFieldGroup, withForm } = createFormHook({
    fieldComponents: {
        AirportAutocompleteField,
        AirportOnlyAutocompleteField,
        CalendarField,
        CheckboxField,
        ColorPickerField,
        CountryAutocompleteField,
        DateField,
        IncrementNumberField,
        MultiDateField,
        MultiSelectAutocompleteField,
        NationalityAutocompleteField,
        NumberField,
        PasswordField,
        RadioGroupField,
        RangeField,
        SelectField,
        SwitchField,
        TextAreaField,
        TextField,
        TimeField,
        TravelClassField,
    },
    fieldContext,
    formComponents: {
        SubscribeButton,
    },
    formContext,
});
